import React from "react";
import PropertyCalendarRoomCell from "./PropertyCalendarRoomCell";
import PropertyCalendarRoomTypeCell from "./PropertyCalendarRoomTypeCell";
import PropertyCalendarReservationSegment from "./PropertyCalendarReservationSegment";
import DateHelper from "../DateHelper/DateHelper";
import { isBefore, isAfter, differenceInDays } from "date-fns";
import { xor } from "lodash";

class PropertyCalendarDateGrid extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {    
    var self = this;
    var room_types_and_rooms = [];
    var room_types_count = 0;
    var rooms_count = 0;
    var idx = 0;

    for (var i = 0, ilen = this.props.room_types.length; i < ilen; i++) {
      var room_type = this.props.room_types[i];
      idx = 0;
      for (
        var d = new Date(this.props.start_date);
        d <= this.props.end_date;
        d.setDate(d.getDate() + 1)
      ) {
        var date_data =
          this.props.date_data[DateHelper.printDateToScreen(d, "yyyy-MM-dd")];
        var room_type_data =
          date_data &&
          date_data.room_types &&
          date_data.room_types[room_type.id]
            ? date_data.room_types[room_type.id]
            : null;
        if (room_type_data) {
          room_types_and_rooms.push(
            <PropertyCalendarRoomTypeCell
              key={"room_type_" + room_type.id + "_" + d}
              room_type_id={room_type.id}
              date={DateHelper.printDateToScreen(d, "yyyy-MM-dd")}
              top={this.calculateTop(room_types_count, rooms_count)}
              left={this.calculateLeft(idx)}
              amount={room_type_data.amount}
              total_rooms={room_type_data.total_rooms}
              rooms_available={room_type_data.rooms_available}
              unassigned_rooms={room_type_data.unassigned_rooms}
              isHousekeeping={this.props.isHousekeeping}
            />
          );
        } else {
          room_types_and_rooms.push(
            <PropertyCalendarRoomTypeCell
              key={"room_type_" + room_type.id + "_" + d}
              room_type_id={room_type.id}
              date={DateHelper.printDateToScreen(d, "yyyy-MM-dd")}
              top={this.calculateTop(room_types_count, rooms_count)}
              left={this.calculateLeft(idx)}
              isHousekeeping={this.props.isHousekeeping}
            />
          );
        }
        idx++;
      }

      room_types_count++;

      if (room_type.collapsed) {
        // do not add the rooms
      } else {
        if (room_type.type_of_booking == "room" || room_type.type_of_booking == "daily") {
          for (var j = 0, jlen = room_type.rooms.length; j < jlen; j++) {
            var room = room_type.rooms[j];

            idx = 0;
            for (
              var d = new Date(this.props.start_date);
              d <= this.props.end_date;
              d.setDate(d.getDate() + 1)
            ) {
              room_types_and_rooms.push(
                <PropertyCalendarRoomCell
                  key={"room_" + room.id + "_" + d}
                  top={this.calculateTop(room_types_count, rooms_count)}
                  left={this.calculateLeft(idx)}
                />
              );
              idx++;
            }

            rooms_count++;
          }
        } else if (room_type.room_groups) {
          for (var j = 0, jlen = room_type.room_groups.length; j < jlen; j++) {
            var room_group = room_type.room_groups[j];

            idx = 0;
            for (
              var d = new Date(this.props.start_date);
              d <= this.props.end_date;
              d.setDate(d.getDate() + 1)
            ) {
              room_types_and_rooms.push(
                <PropertyCalendarRoomCell
                  key={"room_" + room_group.id + "_" + d}
                  top={this.calculateTop(room_types_count, rooms_count)}
                  left={this.calculateLeft(idx)}
                />
              );
              idx++;
            }

            rooms_count++;
          }
        }
      }
    }

    var start_date = new Date(this.props.start_date);
    var end_date = new Date(this.props.end_date);
    var count = 0;
    var reservation_segments = this.props.reservation_segments.map(function (
      reservation_segment
    ) {
      count += 1;
      var check_in_date = DateHelper.parseDateFromBackend(
        reservation_segment.check_in_date
      );
      

      var check_out_date = DateHelper.parseDateFromBackend(
        reservation_segment.check_out_date
      );

      
      var room_type = self.getRoomType(reservation_segment.room_type);

      if (room_type && room_type.collapsed) {
        // do not show the reservation
      } else {
        // console.log("calculateReservationSegmentLef", self.calculateReservationSegmentLeft(reservation_segment,
        //   check_in_date,
        //   check_out_date,
        //   start_date,
        //   end_date,
        //   room_type
        // ))
        return (
          <PropertyCalendarReservationSegment
            key={reservation_segment.id}
            reservation_segment={reservation_segment}
            top={self.calculateReservationSegmentTop(reservation_segment)}
            left={self.calculateReservationSegmentLeft(
              reservation_segment,
              check_in_date,
              check_out_date,
              start_date,
              end_date,
              room_type,
              count
            )}
            width={self.calculateWidth(
              check_in_date,
              check_out_date,
              start_date,
              end_date,
              room_type
            )}
            date_format={self.props.date_format}
            time_format={self.props.time_format}
            view_mode={self.props.view_mode}
            isAfter={isAfter(check_out_date, end_date)}
            isBefore={isBefore(check_in_date, start_date)}
            show_notes={self.props.show_notes}
            show_notifications={self.props.show_notifications}
            show_service_logs={self.props.show_service_logs}
            show_housekeeping={self.props.show_housekeeping}
            room_type={room_type}
            isHousekeeping={self.props.isHousekeeping}
          />
        );
      }
    });

    return (
      <div className="PropertyCalendarDateGrid">
        {room_types_and_rooms}
        {reservation_segments}
      </div>
    );
  }

  /**
   * Helper functions
   */

  calculateReservationSegmentTop(reservation_segment) {
    var rooms_count = 0;
    var room_types_count = 0;

    for (var i = 0, ilen = this.props.room_types.length; i < ilen; i++) {
      var room_type = this.props.room_types[i];
      room_types_count++;

      if (room_type.collapsed) {
        // do not calculate
      } else {
        if (room_type.type_of_booking == "room" || room_type.type_of_booking == "daily") {
          for (var j = 0, jlen = room_type.rooms.length; j < jlen; j++) {
            var room = room_type.rooms[j];
            rooms_count++;

            if (
              reservation_segment.room &&
              room.identifier == reservation_segment.room.identifier &&
              room_type.id == reservation_segment.room_type.id
            ) {
              return room_types_count * 80 + (rooms_count - 1) * 40 + 5;
            }
          }
        } else if (room_type.room_groups) {
          for (var j = 0, jlen = room_type.room_groups.length; j < jlen; j++) {
            var room_group = room_type.room_groups[j];
            rooms_count++;

            if (
              reservation_segment.room_group &&
              room_group.identifier ==
                reservation_segment.room_group.identifier &&
              room_type.id == reservation_segment.room_type.id
            ) {
              return room_types_count * 80 + (rooms_count - 1) * 40 + 5;
            }
          }
        }
      }
    }

    return -9999; // if we don't have a room, position offscreen
  }

  // calculateMarginLeft(
  //   reservation_segment,
  //   check_in_date,
  //   check_out_date,
  //   start_date,
  //   end_date,
  //   room_type,
  // ) {
  //   if (room_type && room_type.type_of_booking == 'daily') {
  //     var width = (this.props.view_mode == "monthly" ? 50 : 170)
  //     var left = (this.props.view_mode == "monthly" ? 25 : 180)
  //   } else  {
  //     var width = (this.props.view_mode == "monthly" ? 50 : 190)
  //     var left = (this.props.view_mode == "monthly" ? 25 : 95)
  //   }


  //   if (isBefore(check_in_date, start_date)) {
  //     console.log('isBefore');
      
  //     return 0;
  //   } else {
  //    return 20
  //   }
  // }

  calculateReservationSegmentLeft(
    reservation_segment,
    check_in_date,
    check_out_date,
    start_date,

    end_date,
    room_type,
  ) {
    if (isBefore(check_in_date, start_date)) {
      if( room_type && room_type.type_of_booking == 'daily') {
        return 13;
      } else {
        return 0;
      }

    } else {
      var days = differenceInDays(check_in_date, this.props.start_date);
      
      
      if (room_type && room_type.type_of_booking == 'daily') {
        // console.log('days', days);
        // console.log('(days) * (this.props.view_mode == "monthly" ? 50 : 190)', (days) * (this.props.view_mode == "monthly" ? 50 : 190))
        // console.log('((days) * (this.props.view_mode == "monthly" ? 50 : 190)) + 13', (days) * (this.props.view_mode == "monthly" ? 50 : 190) + 13)

        return (
          ((days) * (this.props.view_mode == "monthly" ? 50 : 190) + 13) 
        )
      } else {


        return (
          (days + 1) * (this.props.view_mode == "monthly" ? 50 : 190) -
          (this.props.view_mode == "monthly" ? 25 : 95)
        ); // + 140;
      }
    }
  }

  // calculateReservationSegmentLeft(
  //   reservation_segment,
  //   check_in_date,
  //   check_out_date,
  //   start_date,
  //   end_date,
  //   room_type,
  //   count
  // ) {
  //   if (room_type && room_type.type_of_booking == 'daily') {
  //     var width = (this.props.view_mode == "monthly" ? 50 : 170)
  //     var left = (this.props.view_mode == "monthly" ? 25 : 160)
  //   } else  {
  //     var width = (this.props.view_mode == "monthly" ? 50 : 190)
  //     var left = (this.props.view_mode == "monthly" ? 25 : 95)
  //   }


  //   if (isBefore(check_in_date, start_date)) {
  //     // console.log('isBefore', check_in_date, start_date);
      
  //     return 0;
  //   } else {
  //     var days = differenceInDays(check_in_date, this.props.start_date);
  //     if (room_type && room_type.type_of_booking == 'daily') {
  //       // console.log('check_in_date', check_in_date);
  //       // console.log('start_date', start_date);
  //       // console.log('days', days);
  //       // console.log('width', width);
  //       // console.log('left', left);
  //       return (
  //         ((days + 1) * width - left) + (10 * count)
  //       )
  //     } else {
       
        
  //       return (
  //         (days + 1) * width - left
  //       )
  //     }
  //   }
  // }
  calculateWidth(check_in_date, check_out_date, start_date, end_date, room_type) {
    var duration = differenceInDays(check_out_date, check_in_date);
    if (room_type && room_type.type_of_booking == "daily") {
      return duration * (this.props.view_mode == "monthly" ? 25 : 165);
    } else if (isAfter(check_out_date, end_date)) {
      return (
        (duration - differenceInDays(check_out_date, end_date)) *
          (this.props.view_mode == "monthly" ? 50 : 190) +
        (this.props.view_mode == "monthly" ? 25 : 95)
      );
    } else if (isBefore(check_in_date, start_date)) {
      return (
        (duration - differenceInDays(start_date, check_in_date)) *
          (this.props.view_mode == "monthly" ? 50 : 190) +
        (this.props.view_mode == "monthly" ? 25 : 95)
      );
    } else {
      return duration * (this.props.view_mode == "monthly" ? 50 : 190);
    }
  }


  calculateTop(room_types_count, rooms_count) {
    return room_types_count * 80 + rooms_count * 40;
  }

  calculateLeft(idx) {
    // if (!this.props)
    return idx * (this.props.view_mode == "monthly" ? 50 : 190);
  }

  getRoomType(roomType) {
    for (var i = 0, ilen = this.props.room_types.length; i < ilen; i++) {
      if (this.props.room_types[i].id == roomType.id) {
        return this.props.room_types[i];
      }
    }
  }
}

export default PropertyCalendarDateGrid;
